import { Pricing } from '@/types';

import { UnitPricingTier } from './ProductContext';

export const getUnitTierPricing = (
  tier: UnitPricingTier,
  pricing?: Pricing,
): { originalCents: number; saleCents: number } => {
  const originalDollars = tier.price * tier.qty;
  let saleDollars = originalDollars;

  if (pricing?.discount_method === 'PERCENT') {
    saleDollars =
      originalDollars -
      (originalDollars * (pricing.discount_percent ?? 0)) / 100;
  } else {
    saleDollars = originalDollars - (pricing?.discount_amount ?? 0);
  }

  return {
    originalCents: Math.round(originalDollars * 100),
    saleCents: Math.round(Math.max(0, saleDollars) * 100),
  };
};

export const getUnitTierIsSpecial = (
  tier: UnitPricingTier,
  pricing?: Pricing,
): boolean => {
  const { originalCents, saleCents } = getUnitTierPricing(tier, pricing);

  return saleCents < originalCents;
};
